import React from "react";
import "@/App.css";
import { Toaster } from "sonner";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/sections/Hero";
import { Story } from "@/components/sections/Story";
import { Coherence } from "@/components/sections/Coherence";
import { Energetics } from "@/components/sections/Energetics";
import { Pillars } from "@/components/sections/Pillars";
import { Alliance } from "@/components/sections/Alliance";
import { Workbook } from "@/components/sections/Workbook";
import { ForWhom } from "@/components/sections/ForWhom";
import { Connect } from "@/components/sections/Connect";
import { Footer } from "@/components/sections/Footer";
import { MoveThrus } from "@/components/sections/MoveThrus";
import { TheRiff } from "@/components/sections/TheRiff";

const TOAST_OPTIONS = {
  style: {
    background: "#14100c",
    color: "#e8dfc8",
    border: "1px solid rgba(201, 168, 76, 0.35)",
    fontFamily: "Lora, serif",
    borderRadius: 0,
  },
};

function App() {
  return (
    <div className="App" data-testid="app-root">
      <div
        className="honeycomb-ambient"
        aria-hidden="true"
        style={{ backgroundImage: "url('/media/honeycomb-real.jpg')" }}
      />
      <Nav />
      <main>
        <Hero />
        <Story />
        <Coherence />
        <Energetics />
        <TheRiff />
        <Pillars />
        <Alliance />
        <Workbook />
        <ForWhom />
        <MoveThrus />
        <Connect />
      </main>
      <Footer />
      <Toaster position="bottom-center" theme="dark" toastOptions={TOAST_OPTIONS} />
    </div>
  );
}

export default App;
